module.exports = __webpack_public_path__ + "static/vasile-43d6ae250034b0c2a679c3d5bbccc170.jpg";